import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/helpers/auth.guards';
import { WalletGuard } from 'app/auth/helpers/wallet.guard';
import { AdminGuard } from 'app/auth/helpers/admin.guards';
import { HelpResolver } from './resolvers/help.resolver';
import { AdminResolver } from './resolvers/admin.resolver';
import { StockResolver } from './resolvers/stock.resolver';
import { CryptoResolver } from './resolvers/crypto.resolver';
import { NftResolver } from './resolvers/nft.resolver';
import { RegisterComponent } from './common/register/register.component';
import { ProfileComponent } from './common/profile/profile.component';
import { BillingComponent } from './common/billing/billing.component';
import { SubscriptionComponent } from './common/subscription/subscription.component';
import { NotAuthorizedComponent } from './common/not-authorized/not-authorized.component';
import { ErrorComponent } from './common/error/error.component';
import { ForgetPasswordComponent } from './common/forget-password/forget-password.component';
import { ResetPasswordComponent } from './common/reset-password/reset-password.component';

const routes: Routes = [
  
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'crypto'
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  // {
  //   path: 'login',
  //   component: LoginComponent
  // },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'forgot-password',
    component: ForgetPasswordComponent
  },
  /* STOCK */
  {
    path: 'stock',
    loadChildren: () => import('./sections/stocks/stocks.module').then(m => m.StocksModule),
    data: { icon: false },
    resolve: {
      stock: StockResolver
    }
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [AdminGuard],
    data: { animation: 'danalytics' },
    resolve: {
      admin: AdminResolver
    }
  },
  {
    path: 'crypto',
    loadChildren: () => import('./sections/crypto/crypto.module').then(m => m.CryptoModule),
    resolve: {
      crypto: CryptoResolver
    },
    data: { icon: false },
  },
  {
    path: 'nft',
    loadChildren: () => import('./sections/nft/nft.module').then(m => m.NftModule),
    resolve: {
      nft : NftResolver
    },
    data: { icon: false },
  },
  {
    path: 'help',
    loadChildren: () => import('./sections/help/help.module').then(m => m.HelpModule),
    data: { icon: false },
    resolve: {
      help: HelpResolver
    }
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard, WalletGuard],
    data: { animation: 'profile', icon: true },
  },
  {
    path: 'billing',
    component: BillingComponent,
    canActivate: [AuthGuard, WalletGuard],
    data: { animation: 'billing', icon: true },
  },
  {
    path: 'subscription',
    component: SubscriptionComponent,
    canActivate: [AuthGuard, WalletGuard],
    data: { animation: 'subscription', icon: true },
  },
  {
    path: 'unauthorized',
    component: NotAuthorizedComponent
  },
  {
    path: '**',
    component: ErrorComponent
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', // Add options right here
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }